var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVegan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 1C19.6275 1 25.0001 6.3726 25.0001 13C25.0001 19.6275 19.6275 25.0001 13 25.0001C6.37259 25.0001 0.99999 19.6275 0.99999 13C0.999989 6.3726 6.37259 1.00001 13 1Z",
    stroke: "#66BA48",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3977 19.5041C12.7664 17.4945 13.1559 10.1874 5.48779 7.90976L12.3977 19.5041Z",
    fill: "#66BA48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.43616 7.89411C5.43302 7.89307 5.42989 7.89237 5.42675 7.89133C5.42675 7.89133 2.49818 18.1357 11.9934 19.9718L5.43616 7.89411Z",
    fill: "#66BA48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8935 18.9793C12.6053 16.8689 12.5471 9.24118 20.6404 7.23398L12.8935 18.9793Z",
    fill: "#66BA48"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6951 7.22052C20.6986 7.21982 20.7017 7.21878 20.7052 7.21808C20.7052 7.21808 23.2672 18.0253 13.2925 19.4857L20.6951 7.22052Z",
    fill: "#66BA48"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVegan);
export default __webpack_public_path__ + "static/media/icon-vegan.431fcca70fbe858e9635c3ba21ef3ad3.svg";
export { ForwardRef as ReactComponent };